/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'

import axios from 'axios'
import { Link } from 'react-router-dom'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'

import Security from './Security'
import GiveFeedback from './GiveFeedback'

import useWindowDimensions from '../../helpers/windowDimensions'
import { getPayload, userIsAuthenticated, getTokenFromLocalStorage } from '../../helpers/storage'
import { seoPageTags } from '../../helpers/analytics'
import { standardSpinner } from '../../helpers/spinners'
import { navbarHeight, hingeProfileBackgroundColor, dashboardNavbarHeight, footerHeight, positionChangeWidthSm } from '../../helpers/variableDefaults'
import { makeTabIndex } from '../../helpers/formatting'
import { standardErrorContainer } from '../../helpers/errors'
import { saveSuccessfulTypography, advisoryTypography } from '../../helpers/typographies'
import { standardButton } from '../../helpers/buttons'

// Friend Review Not Found Page
const FriendReview = (props) => {
  
  // Window Dimensions
  const { height, width } = useWindowDimensions()
    
  // Navigate
  const navigate = useNavigate()
  
  // Params
  const { datingProfileId, profileReviewId } = useParams()

  // States
  const [securityCode, setSecurityCode] = useState('')
  const [securityPassed, setSecurityPassed] = useState(false)
  const [friendProfileReview, setFriendProfileReview] = useState({})

  // Errors and Loading
  const [loading, setLoading] = useState(false)
  const [securityLoading, setSecurityLoading] = useState(false)
  const [errors, setErrors] = useState(false) 
  const [securityErrors, setSecurityErrors] = useState(false) 

  useEffect(() => {
    // console.log('useEffect runs')
    
    const fetchData = async () => {
      setLoading(true)
      //   // console.log('userId ->', userId)
      
      try {
        // console.log('fetch data runs')
        const { data } = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/profile-reviews/${profileReviewId}`)

        // console.log('data.profileReview ->', data.profileReview)

        if (
          data.profileReview._id === profileReviewId
        ) {
          // console.log('states should set')
          setFriendProfileReview(data.profileReview)
          setSecurityCode(data.profileReview.securityCode)

          setLoading(false)
          // console.log('no longer loading')

        } else {
          // console.log('states should not set')
          navigate(`/`)
          setLoading(false)
        }

      } catch (err) {
        console.log('friend review fetch error ->', err)

        navigate('/')
        setLoading(false)
      }
    }
    fetchData()

  }, [])

  useEffect(() => {
    // console.log('value useEffect Runs')

  }, [securityCode, securityPassed])

  return (
    <>
      {/* Helmet — for analytics, seo, and page title changing */}
      {seoPageTags(
        'Friend Review'
      )}

      {/* Body */}
      {loading ?
        <Box sx={{ 
          width: '100%',
          // minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight} - ${dashboardNavbarHeight})`,
          minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight})`,
          mt: 0, mb: 0,
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', 
        }}>
          {standardSpinner()}
        </Box>
        :
        <Box 
          sx={{ 
            minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight})`, 
            width: '100vw', 
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', 
          }}
        >

          {/* Security Modal is open until the correct security code is input */}
          {!securityPassed &&
            <Security 
              securityCode={securityCode} securityPassed={securityPassed} setSecurityPassed={setSecurityPassed}
            />
          }

          {securityPassed 
            && friendProfileReview !== null
            && friendProfileReview !== undefined
            && Object.keys(friendProfileReview).length > 0
            && 'reviewSubmitted' in friendProfileReview
            && !friendProfileReview.reviewSubmitted
            ?
            <GiveFeedback isFriendReview={true} friendProfileReview={friendProfileReview} />
            :
            friendProfileReview.reviewSubmitted
              ?
              <Box
                sx={{ 
                  height: `calc(100vh - ${navbarHeight} - ${footerHeight})`, 
                  width: '100vw', 
                  display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', 
                }}
              >
                Review Submitted Successfully!
              </Box>
              :
              <Box
                sx={{ 
                  height: `calc(100vh - ${navbarHeight} - ${footerHeight})`, 
                  width: '100vw', 
                  display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', 
                }}
              >
                Error loading data. Check your Internet connection and try again.
              </Box>
          }

        </Box>
      }
    </>
  )
}

export default FriendReview